import { z } from "zod";

/**
 * HUB-525: Zod 4 compiles object parsers with `new Function` when the runtime allows it, and
 * it finds out by probing `new Function("")` inside a try/catch the first time an object schema
 * is built. The throw is swallowed, but a strict CSP (`script-src 'self'`, no `unsafe-eval`)
 * still reports the attempt as a `securitypolicyviolation` — the `blockedURI: "eval"` the
 * Production Security job caught on PR #339 (and the flag PR #233 saw with drizzle-zod 0.8).
 *
 * `jitless` skips both the probe and the compiled fast path; parsing results are identical,
 * only the object-parsing speed differs. This module must be the FIRST import of the client
 * entry so it runs before any module that builds a schema (`shared/schema.ts` builds dozens at
 * load). Guarded by client/src/lib/zod-config.test.ts.
 */
z.config({ jitless: true });
